module.exports = __webpack_public_path__ + "static/smoke-4-54cab8d2139feb66c32250c67fdf5c59.mp4";